import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../supabaseClient";
import { CircularProgress, Box, Typography } from "@mui/material";

const AuthCallback = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true); // ✅ 로딩 상태 추가

  useEffect(() => {
    let isMounted = true; // ✅ 언마운트 방지 플래그

    const checkAuth = async () => {
      setLoading(true);
      const { data: { session } } = await supabase.auth.getSession();

      if (isMounted) {
        if (session) {
          navigate("/"); // ✅ 로그인 성공 시 이동
        } else {
          navigate("/login"); // ✅ 로그인 실패 시 이동
        }
      }
    };

    checkAuth();

    return () => {
      isMounted = false; // ✅ 클린업 처리
    };
  }, [navigate]);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", mt: 10 }}>
      {loading ? (
        <>
          <CircularProgress /> {/* ✅ 로딩 UI 추가 */}
          <Typography sx={{ mt: 2 }}>로그인 처리 중...</Typography>
        </>
      ) : (
        <Typography>로그인 결과를 확인 중...</Typography>
      )}
    </Box>
  );
};

export default AuthCallback;
